<div class="projects-summary-stages">
    <!-- <div [hidden]="!accessUpdateStage || nextStages !=null && nextStages.length == 0" class="project-stage-step" (click)="openNextStages()">
      <core-helpers-box-loading [hidden]="!loadingNextStages"></core-helpers-box-loading>
    </div> -->
    <!-- TODO: manage accessUpdateStage -->
    <div [hidden]="nextStages == null || (nextStages != null && nextStages.length > 0)" class="project-stage-none" >
        <core-helpers-box-alert-message-icon
          [text]="''"
          [icon]="'stop_move'"
        ></core-helpers-box-alert-message-icon>
    </div>
    <div class="project-stage-fake-combo" [hidden]="(nextStages !=null && nextStages.length == 0)">
      <div class="project-stage-fake-combo-item" *ngFor="let stage of nextStages">
          <!-- <h4 class="" (click)="updateStage(stage)"><em>{{stage.name}}</em></h4> -->
          <h4 class="" [style.background-color]="stage.color ? stage.color :''" (click)="updateStage(stage)"><em>{{stage.name}}</em></h4>
      </div>
    </div>
</div>